const options = {
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  }
}

export default {
  name: 'Slider',

  props: {
    totalSlides: {
      required: true,
      type: Number
    }
  },

  data: function() {
    return {
      swiperComponentOption: options
    }
  }
}
